<template>
    <div class="table"
        element-loading-background = "rgba(255, 255,255,0.7)"
        :element-loading-text = "loadingText"
        v-loading="loading" 
        > 
        <div style="z-index: 9999;position:fixed;margin-left:780px;margin-top:220px;">
            <div><el-button type="primary" round @click="save()"  v-if="selectSign == 1" style="width:120px;">点此草稿保存</el-button></div>
            <div><el-button type="primary" round  @click="save()"  v-if="selectSign == 2 || selectSign == 3" style="width:120px;">提交</el-button></div>
            <!-- <div><el-button type="danger" round  @click="save()" style="width:100px;margin-top:5px;">关闭</el-button></div> -->
        </div>
        
        <div v-for="(indexItem, indexN) in indexData" :key="indexN">
            
            <!-- 填写-->
            <div v-if="selectSign == 1"> 

                <div>
                    <span v-html="indexItem.indexName"></span>
                    <span v-if="indexItem.indexType == 'select'">
                        <el-select v-model="form.indexName['indexName'+indexN]"  clearable style="width:60%;"
                            collapse-tags placeholder="请选择">
                            <el-option
                                v-for="item in indexItem.indexSourceData"
                                :key="item.index1"
                                :label="item.index1"
                                :value="item.index1">
                            </el-option>
                        </el-select>
                    </span>
                </div>

                <div v-if="indexItem.indexType == 'select'">
                    <span   v-for="(indexSourceData, i) in indexItem.indexSourceData" :key="i">
                        <span v-if="form.indexName['indexName'+indexN] == indexSourceData.index1" v-html="indexSourceData.index2"></span>
                    </span>
                </div>

                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="自我评述（必填）"
                    v-model="form.selfComment['selfComment'+indexN]"
                    maxlength="300"
                    rows="3"
                    show-word-limit>
                </el-input>

                <div>
                    <div class="add-file-right" style="height:25px;">
                        <span class="add-file-right-img" >上传文件：</span>
                        <input type="file" ref="clearFile" @change="getFile($event,indexN)" class="add-file-right-input" accept="*">
                    </div>
                    <div class="add-file-list">
                        <ul>
                            <li v-for="(item, index) in form.selfCommentFile['selfCommentFile'+indexN]" :key="index" style="list-style-type: none;">
                                <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button><el-button type="text" @click="deleteFile(item.filePath)" style="margin-left:10px;cursor:pointer;color:red;">删除</el-button> 
                            </li>
                        </ul>
                    </div>
                </div>

                <div  v-if="indexItem.indexScoreType == 1 ">
                    <el-select  style="margin-top:5px;"
                        v-model="form.selfScoreLabel['selfScoreLabel'+indexN]" clearable placeholder="请选择自评得分">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </div>

                <div  v-if="indexItem.indexScoreType == 2 ">
                    <el-select  style="margin-top:5px;"
                        v-model="form.selfScoreLabel['selfScoreLabel'+indexN]" clearable placeholder="请选择自评得分">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.selfScore['selfScore'+indexN]"  placeholder="请输入自评得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,1)" style="width:150px;margin-top:5px;"></el-input>
                </div>

                <div  v-if="indexItem.indexScoreType == 3 ">
                    <el-input v-model="form.selfScore['selfScore'+indexN]"  placeholder="请输入自评得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,1)" style="width:150px;margin-top:5px;"></el-input>
                </div>

                <div  v-if="indexItem.indexScoreType == 4 ">
                    <div v-if="indexItem.indexType == 'student'">
                        <div v-for="(s, n) in form.selfDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                            <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,1)"
                                    :options="levelData" filterable
                                    v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                    :props="{ expandTrigger: 'hover' }"
                                    placeholder="请选择级别（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-input v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入项目名称（必填）" maxlength="10" style="width:180px;"></el-input>
                            <el-cascader  style="width:200px;"
                                    :options="students" filterable
                                    v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['indexStudent']"
                                    :props="props"
                                    placeholder="请选择学生（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,1)">删除</el-button>
                        </div>
                        <div style="font-size:15px;font-weight:bold;">自评得分：{{form.selfScore['selfScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,1)">新增</el-button></div>
                    </div>

                    <div v-else-if="indexItem.indexType == 'self'">
                        <div v-for="(s, n) in form.selfDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                            <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,1)"
                                    :options="citeData" filterable
                                    v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                    :props="{ expandTrigger: 'hover' }"
                                    placeholder="请选择表彰（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-input v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入表彰项目（必填）" maxlength="10" style="width:180px;"></el-input>
                            <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,1)">删除</el-button>
                        </div>
                        <div style="font-size:15px;font-weight:bold;">自评得分：{{form.selfScore['selfScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,1)">新增</el-button></div>
                    </div>

                </div>
            </div>
            <!-- 学校审批-->
            <div v-if="selectSign == 2">

                <div>
                    <span v-html="indexItem.indexName"></span>
                    <span v-if="indexItem.indexType == 'select'">
                        <el-select v-model="form.indexName['indexName'+indexN]"  :disabled="true" style="width:60%;"
                            collapse-tags placeholder="请选择">
                            <el-option
                                v-for="item in indexItem.indexSourceData"
                                :key="item.index1"
                                :label="item.index1"
                                :value="item.index1">
                            </el-option>
                        </el-select>
                    </span>
                </div>

                <div v-if="indexItem.indexType == 'select'">
                    <span   v-for="(indexSourceData, i) in indexItem.indexSourceData" :key="i">
                        <span v-if="form.indexName['indexName'+indexN] == indexSourceData.index1" v-html="indexSourceData.index2"></span>
                    </span>
                </div>
                
                <div style="font-size:15px;font-weight:bold;">自我评述：</div>
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="自我评述"
                    v-model="form.selfComment['selfComment'+indexN]"
                    maxlength="300"
                    rows="3"
                    :disabled="true"
                    show-word-limit>
                </el-input>

                <div class="add-file-list">
                    <ul>
                        <li v-for="(item, index) in form.selfCommentFile['selfCommentFile'+indexN]" :key="index" style="list-style-type: none;">
                            <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button> 
                        </li>
                    </ul>
                </div>
                <!--自定义分数-->
                <div v-for="(item, index) in form.selfDefineScore[indexItem.id+'defineLabel'+indexN]" :key="index" >
                    <span v-if="indexItem.indexType == 'student'">{{item.id}}/{{item.item}},获奖的学生有：{{item.indexStudent}}</span>
                    <span v-if="indexItem.indexType == 'self'">{{item.id}}/{{item.item}}</span>
                </div>
                <!--学生重复申请-->
                <div v-if="form.selfStudentExist[indexItem.id+'selfStudentExist'+indexN]!=null" style="color:red;">
                    备注：
                    <div v-html="form.selfStudentExist[indexItem.id+'selfStudentExist'+indexN]"></div>
                </div>

                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 1">自评得分：{{indexItem.selfScoreLabel==''?'无':indexItem.selfScoreLabel}}</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 2">自评得分：{{indexItem.selfScoreLabel==''?'无':indexItem.selfScoreLabel}}({{indexItem.selfScore}}分)</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 3 || indexItem.indexScoreType == 4">自评得分：{{indexItem.selfScore}}分</div>
                 
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="学校批注（必填）"
                    v-model="form.schoolComments['schoolComments'+indexN]"
                    maxlength="300"
                    rows="3"
                    show-word-limit>
                </el-input>
                <div  v-if="indexItem.indexScoreType == 1 ">
                    <el-select  style="margin-top:5px;"
                        v-model="form.schoolScoreLabel['schoolScoreLabel'+indexN]" clearable placeholder="请选择学校得分">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </div>

                <div  v-if="indexItem.indexScoreType == 2 ">
                    <el-select  style="margin-top:5px;"
                        v-model="form.schoolScoreLabel['schoolScoreLabel'+indexN]" clearable placeholder="请选择学校得分">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.schoolScore['schoolScore'+indexN]" placeholder="请输入学校得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,2)" style="width:150px;margin-top:5px;"></el-input>
                </div>

                <div  v-if="indexItem.indexScoreType == 3 ">
                    <el-input v-model="form.schoolScore['schoolScore'+indexN]" placeholder="请输入学校得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,2)" style="width:150px;margin-top:5px;"></el-input>
                </div>

                <div  v-if="indexItem.indexScoreType == 4 ">
                    <div v-if="indexItem.indexType == 'student'">
                        <div v-for="(s, n) in form.schoolDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                            <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,2)"
                                    :options="levelData" filterable
                                    v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                    :props="{ expandTrigger: 'hover' }"
                                    placeholder="请选择级别（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-input v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入项目名称（必填）" maxlength="10" style="width:180px;"></el-input>
                            <el-cascader  style="width:200px;"
                                    :options="students" filterable
                                    v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['indexStudent']"
                                    :props="props"
                                    placeholder="请选择学生（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,2)">删除</el-button>
                        </div>
                        <div style="font-size:15px;font-weight:bold;">学校得分：{{form.schoolScore['schoolScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,2)">新增</el-button></div>
                    </div>

                    <div v-else-if="indexItem.indexType == 'self'">
                        <div v-for="(s, n) in form.schoolDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                            <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,2)"
                                    :options="citeData" filterable
                                    v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                    :props="{ expandTrigger: 'hover' }"
                                    placeholder="请选择表彰（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-input v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入表彰项目（必填）" maxlength="10" style="width:180px;"></el-input>
                            <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,2)">删除</el-button>
                        </div>
                        <div style="font-size:15px;font-weight:bold;">学校得分：{{form.schoolScore['schoolScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,2)">新增</el-button></div>
                    </div>
                </div>
            </div>
            
            <div v-if="selectSign == 3">

                <div>
                    <span v-html="indexItem.indexName"></span>
                    <span v-if="indexItem.indexType == 'select'">
                        <el-select v-model="form.indexName['indexName'+indexN]"  :disabled="true" style="width:60%;"
                            collapse-tags placeholder="请选择">
                            <el-option
                                v-for="item in indexItem.indexSourceData"
                                :key="item.index1"
                                :label="item.index1"
                                :value="item.index1">
                            </el-option>
                        </el-select>
                    </span>
                </div>

                <div v-if="indexItem.indexType == 'select'">
                    <span   v-for="(indexSourceData, i) in indexItem.indexSourceData" :key="i">
                        <span v-if="form.indexName['indexName'+indexN] == indexSourceData.index1" v-html="indexSourceData.index2"></span>
                    </span>
                </div>
                
                <div style="font-size:15px;font-weight:bold;">自我评述：</div>
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="自我评述"
                    v-model="form.selfComment['selfComment'+indexN]"
                    maxlength="300"
                    rows="3"
                    :disabled="true"
                    show-word-limit>
                </el-input>

                <div class="add-file-list">
                    <ul>
                        <li v-for="(item, index) in form.selfCommentFile['selfCommentFile'+indexN]" :key="index" style="list-style-type: none;">
                            <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button> 
                        </li>
                    </ul>
                </div>
                <!--自定义分数-->
                <div v-for="(item, index) in form.selfDefineScore[indexItem.id+'defineLabel'+indexN]" :key="index" >
                    <span v-if="indexItem.indexType == 'student'">{{item.id}}/{{item.item}},获奖的学生有：{{item.indexStudent}}</span>
                    <span v-if="indexItem.indexType == 'self'">{{item.id}}/{{item.item}}</span>
                </div>
                <!--学生重复申请-->
                <div v-if="form.selfStudentExist[indexItem.id+'selfStudentExist'+indexN]!=null" style="color:red;">
                    备注：
                    <div v-html="form.selfStudentExist[indexItem.id+'selfStudentExist'+indexN]"></div>
                </div>

                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 1">自评得分：{{indexItem.selfScoreLabel==''?'无':indexItem.selfScoreLabel}}</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 2">自评得分：{{indexItem.selfScoreLabel==''?'无':indexItem.selfScoreLabel}}({{indexItem.selfScore}}分)</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 3 || indexItem.indexScoreType == 4">自评得分：{{indexItem.selfScore}}分</div>
                
                <div style="font-size:15px;font-weight:bold;">学校批注：</div> 
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="学校批注（必填）"
                    :disabled="true"
                    v-model="form.schoolComments['schoolComments'+indexN]"
                    maxlength="300"
                    rows="3"
                    show-word-limit>
                </el-input>
                 <!--自定义分数-->
                <div v-for="(item, index) in form.schoolDefineScore[indexItem.id+'defineLabel'+indexN]" :key="index" >
                    <span v-if="indexItem.indexType == 'student'">{{item.id}}/{{item.item}},获奖的学生有：{{item.indexStudent}}</span>
                    <span v-if="indexItem.indexType == 'self'">{{item.id}}/{{item.item}}</span>
                </div>

                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 1">学校得分：{{indexItem.schoolScoreLabel==''?'无':indexItem.schoolScoreLabel}}</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 2">学校得分：{{indexItem.schoolScoreLabel==''?'无':indexItem.schoolScoreLabel}}({{indexItem.schoolScore}}分)</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 3 || indexItem.indexScoreType == 4">学校得分：{{indexItem.schoolScore}}分</div>
                  
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="学区批注（必填）"
                    v-model="form.areaComments['areaComments'+indexN]"
                    maxlength="300"
                    rows="3"
                    show-word-limit>
                </el-input>
                <div  v-if="indexItem.indexScoreType == 1 ">
                    <el-select  style="margin-top:5px;"
                        v-model="form.areaScoreLabel['areaScoreLabel'+indexN]" clearable placeholder="请选择学区得分">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </div>

                <div  v-if="indexItem.indexScoreType == 2 ">
                    <el-select  style="margin-top:5px;"
                        v-model="form.areaScoreLabel['areaScoreLabel'+indexN]" clearable placeholder="请选择学区得分">
                        <el-option
                            v-for="item in scoreTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.areaScore['areaScore'+indexN]" placeholder="请输入学区得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,3)" style="width:150px;margin-top:5px;"></el-input>
                </div>

                <div  v-if="indexItem.indexScoreType == 3 ">
                    <el-input v-model="form.areaScore['areaScore'+indexN]" placeholder="请输入学区得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,3)" style="width:150px;margin-top:5px;"></el-input>
                </div>

                <div  v-if="indexItem.indexScoreType == 4 ">
                    <div v-if="indexItem.indexType == 'student'">
                        <div v-for="(s, n) in form.areaDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                            <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,3)"
                                    :options="levelData" filterable
                                    v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                    :props="{ expandTrigger: 'hover' }"
                                    placeholder="请选择级别（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-input v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入项目名称（必填）" maxlength="10" style="width:180px;"></el-input>
                            <el-cascader  style="width:200px;"
                                    :options="students" filterable
                                    v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['indexStudent']"
                                    :props="props"
                                    placeholder="请选择学生（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,3)">删除</el-button>
                        </div>
                        <div style="font-size:15px;font-weight:bold;">学区得分：{{form.areaScore['areaScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,3)">新增</el-button></div>
                    </div>

                    <div v-else-if="indexItem.indexType == 'self'">
                        <div v-for="(s, n) in form.areaDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                            <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,3)"
                                    :options="citeData" filterable
                                    v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                    :props="{ expandTrigger: 'hover' }"
                                    placeholder="请选择表彰（必填）"
                                    collapse-tags
                                    clearable>
                            </el-cascader>
                            <el-input v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入表彰项目（必填）" maxlength="10" style="width:180px;"></el-input>
                            <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,3)">删除</el-button>
                        </div>
                        <div style="font-size:15px;font-weight:bold;">学区得分：{{form.areaScore['areaScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,3)">新增</el-button></div>
                    </div>
                </div>
            
            </div>
            
            
            <div v-if="selectSign == 4">

                <div>
                    <span v-html="indexItem.indexName"></span>
                    <span v-if="indexItem.indexType == 'select'">
                        <el-select v-model="form.indexName['indexName'+indexN]"  :disabled="true" style="width:60%;"
                            collapse-tags placeholder="请选择">
                            <el-option
                                v-for="item in indexItem.indexSourceData"
                                :key="item.index1"
                                :label="item.index1"
                                :value="item.index1">
                            </el-option>
                        </el-select>
                    </span>
                </div>

                <div v-if="indexItem.indexType == 'select'">
                    <span   v-for="(indexSourceData, i) in indexItem.indexSourceData" :key="i">
                        <span v-if="form.indexName['indexName'+indexN] == indexSourceData.index1" v-html="indexSourceData.index2"></span>
                    </span>
                </div>
                
                <div style="font-size:15px;font-weight:bold;">自我评述：</div>
                <el-input style="margin-top:5px;"
                    type="textarea"
                    placeholder="自我评述"
                    v-model="form.selfComment['selfComment'+indexN]"
                    maxlength="300"
                    :readonly="true"
                    rows="3"
                    show-word-limit>
                </el-input>

                <div class="add-file-list">
                    <ul>
                        <li v-for="(item, index) in form.selfCommentFile['selfCommentFile'+indexN]" :key="index" style="list-style-type: none;">
                            <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button> 
                        </li>
                    </ul>
                </div>
                <!--自定义分数-->
                <div v-for="(item, index) in form.selfDefineScore[indexItem.id+'defineLabel'+indexN]" :key="index" >
                    <span v-if="indexItem.indexType == 'student'">{{item.id}}/{{item.item}},获奖的学生有：{{item.indexStudent}}</span>
                    <span v-if="indexItem.indexType == 'self'">{{item.id}}/{{item.item}}</span>
                </div>
                <!--学生重复申请-->
                <div v-if="form.selfStudentExist[indexItem.id+'selfStudentExist'+indexN]!=null" style="color:red;">
                    备注：
                    <div v-html="form.selfStudentExist[indexItem.id+'selfStudentExist'+indexN]"></div>
                </div>

                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 1">自评得分：{{indexItem.selfScoreLabel==''?'无':indexItem.selfScoreLabel}}</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 2">自评得分：{{indexItem.selfScoreLabel==''?'无':indexItem.selfScoreLabel}}({{indexItem.selfScore}}分)</div>
                <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 3 || indexItem.indexScoreType == 4">自评得分：{{indexItem.selfScore}}分</div>
                
                <div v-if=" form.schoolComments['schoolComments'+indexN]!=undefined 
                            && form.schoolComments['schoolComments'+indexN]!='' ">
                    <div style="font-size:15px;font-weight:bold;">学校批注：</div>
                    <el-input style="margin-top:5px;"
                        type="textarea"
                        placeholder="学校批注（必填）"
                        v-model="form.schoolComments['schoolComments'+indexN]"
                        maxlength="300"
                        :readonly="true"
                        rows="3"
                        show-word-limit>
                    </el-input>
                    <!--自定义分数-->
                    <div v-for="(item, index) in form.schoolDefineScore[indexItem.id+'defineLabel'+indexN]" :key="index" >
                        <span v-if="indexItem.indexType == 'student'">{{item.id}}/{{item.item}},获奖的学生有：{{item.indexStudent}}</span>
                        <span v-if="indexItem.indexType == 'self'">{{item.id}}/{{item.item}}</span>
                    </div>

                    <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 1">学校得分：{{indexItem.schoolScoreLabel==''?'无':indexItem.schoolScoreLabel}}</div>
                    <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 2">学校得分：{{indexItem.schoolScoreLabel==''?'无':indexItem.schoolScoreLabel}}({{indexItem.schoolScore}}分)</div>
                    <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 3 || indexItem.indexScoreType == 4">学校得分：{{indexItem.schoolScore}}分</div>
                </div>

                <div v-if=" form.areaComments['areaComments'+indexN]!=undefined 
                            && form.areaComments['areaComments'+indexN]!='' ">
                    <div style="font-size:15px;font-weight:bold;">学区批注：</div>
                    <el-input style="margin-top:5px;"
                        type="textarea"
                        placeholder="学区批注（必填）"
                        :readonly="true"
                        v-model="form.areaComments['areaComments'+indexN]"
                        maxlength="300"
                        rows="3"
                        show-word-limit>
                    </el-input>
                    <!-- <div>学区得分：{{indexItem.areaScoreLabel}}({{indexItem.areaScore}}分)</div> -->
                    <!--自定义分数-->
                    <div v-for="(item, index) in form.areaDefineScore[indexItem.id+'defineLabel'+indexN]" :key="index" >
                        <span v-if="indexItem.indexType == 'student'">{{item.id}}/{{item.item}},获奖的学生有：{{item.indexStudent}}</span>
                        <span v-if="indexItem.indexType == 'self'">{{item.id}}/{{item.item}}</span>
                    </div>

                    <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 1">学区得分：{{indexItem.areaScoreLabel==''?'无':indexItem.areaScoreLabel}}</div>
                    <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 2">学区得分：{{indexItem.areaScoreLabel==''?'无':indexItem.areaScoreLabel}}({{indexItem.areaScore}}分)</div>
                    <div style="font-size:15px;font-weight:bold;" v-if="indexItem.indexScoreType == 3 || indexItem.indexScoreType == 4">学区得分：{{indexItem.areaScore}}分</div>
                </div>
            </div>
            
            <el-divider></el-divider>
        </div>

    </div>
</template>

<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                isReadonly:true,
                indexData:[
                ],
                deptId:"",
                tabTitle:"",
                selectSign:"",
                selectName:"",
                teacherTemplateManageId:"",
                props: { multiple: true},
                form:{
                    indexId:[],
                    indexName:{},
                    selfCommentFile:{},
                    selfComment:{},
                    selfDefineScore:{},
                    selfStudentExist:{},
                    selfScore:{},
                    selfScoreLabel:{},
                    schoolComments:{},
                    schoolDefineScore:{},
                    schoolScore:{},
                    schoolScoreLabel:{},
                    areaComments:{},
                    areaDefineScore:{},
                    areaScore:{},
                    areaScoreLabel:{},
                },
                scoreTypes:[],
                students:[],
                levelData:[], // 级别
                citeData:[], // 表彰
                uploadUrl:"",
                loading:false,
                loadingText:"",
            }
        },
        components: {
        },
        mounted:function () {
            // 获取学校ID
            let deptId=sessionStorage.getItem("selectDeptId");
            this.deptId=deptId;

            // 获取选中的tab
            let tabTitle=sessionStorage.getItem("selectTabTitle");
            this.tabTitle=tabTitle;

            // 获取绩效ID
            let teacherTemplateManageId=sessionStorage.getItem("selectId");
            this.teacherTemplateManageId=teacherTemplateManageId;

            // sign:1-填写，2-学校审批，3-学区审批，4-查看
            let selectSign=sessionStorage.getItem("selectSign");
            this.selectSign=selectSign;

            // 考核人
            let selectName=sessionStorage.getItem("selectName");
            this.selectName=selectName;

            this.uploadUrl=this.uploadIndexFileUrl;
            // 指标初始
            this.initData();
        },
        methods:{
            // 初始数据
            initData(){ // 只执行一次
                // 评分等级初始设置
                this.getScoreTypes();

                // 初始学生数据
                this.getStudents();

                // 初始级别或者表彰
                this.getBaseTypeCascader(2);
                this.getBaseTypeCascader(3);

                // 获取数据
                this.getData();
            },
            // 获取数据
            getData(){
                let url  = this.teacherAssessIndexListUrl;
                let data = {
                    deptId:this.deptId,
                    tabTitle:this.tabTitle,
                    teacherAssessId:this.teacherTemplateManageId
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                        // 初始化数据，将数据对象转成json
                        let tempData=[];
                        for(let i=0;i<res.data.length;i++){
                           let obj=res.data[i];
                           if(obj.indexType == 'select'){ // 下拉选择
                               obj.indexSourceData=JSON.parse(obj.indexSourceData);
                               // 赋值展示选中的指标
                               this.$set(this.form.indexName, 'indexName'+i,obj.indexConfigData);

                           }else if(obj.indexType == 'student'){ // 学生
                                
                                // 自评得分
                                if(obj.selfDefineScore!=undefined){
                                    let selfDefineScore=JSON.parse(obj.selfDefineScore).value;
                                    let selfDefineScoreLabel=JSON.parse(obj.selfDefineScore).label;
                                    let arrData=[];
                                    for(let n=0;n<selfDefineScore.length;n++){
                                        let arrObj=selfDefineScore[n];
                                        let objTemp1={};
                                        objTemp1.id=arrObj.id;
                                        objTemp1.item=arrObj.item;
                                        objTemp1.indexStudent=arrObj.indexStudent;
                                        arrData.push(objTemp1);
                                    }
                                    // console.log(JSON.stringify(selfDefineScoreLabel));
                                    this.$set(this.form.selfDefineScore, obj.id+'define'+i,arrData);
                                    this.$set(this.form.selfDefineScore, obj.id+'defineLabel'+i,selfDefineScoreLabel);
                                }else{
                                    // 选择值为空不存在，使用默认的
                                    let objTemp1={};objTemp1.id=[];objTemp1.item="";objTemp1.indexStudent=[];
                                    let data1=[];data1.push(objTemp1);
                                    this.$set(this.form.selfDefineScore, obj.id+'define'+i,data1);
                                }
                                // 是否存在该学生存在多个老师同时申请情况
                                if(obj.selfStudentExist!=undefined){
                                    this.$set(this.form.selfStudentExist, obj.id+'selfStudentExist'+i,obj.selfStudentExist);
                                }

                                // 学校得分
                                if(obj.schoolDefineScore!=undefined){
                                    let schoolDefineScore=JSON.parse(obj.schoolDefineScore).value;
                                    let schoolDefineScoreLabel=JSON.parse(obj.schoolDefineScore).label;
                                    let arrData=[];
                                    for(let n=0;n<schoolDefineScore.length;n++){
                                        let arrObj=schoolDefineScore[n];
                                        let objTemp1={};
                                        objTemp1.id=arrObj.id;
                                        objTemp1.item=arrObj.item;
                                        objTemp1.indexStudent=arrObj.indexStudent;
                                        arrData.push(objTemp1);
                                    }
                                    this.$set(this.form.schoolDefineScore, obj.id+'define'+i,arrData);
                                    this.$set(this.form.schoolDefineScore, obj.id+'defineLabel'+i,schoolDefineScoreLabel);
                                }else{
                                    // 选择值为空不存在，使用默认的
                                    let objTemp2={};objTemp2.id=[];objTemp2.item="";objTemp2.indexStudent=[];
                                    let data2=[];data2.push(objTemp2);
                                    this.$set(this.form.schoolDefineScore, obj.id+'define'+i,data2);
                                }
                                
                                // 学区得分
                                if(obj.areaDefineScore!=undefined){
                                    let areaDefineScore=JSON.parse(obj.areaDefineScore).value;
                                    let areaDefineScoreLabel=JSON.parse(obj.areaDefineScore).label;
                                    let arrData=[];
                                    for(let n=0;n<areaDefineScore.length;n++){
                                        let arrObj=areaDefineScore[n];
                                        let objTemp1={};
                                        objTemp1.id=arrObj.id;
                                        objTemp1.item=arrObj.item;
                                        objTemp1.indexStudent=arrObj.indexStudent;
                                        arrData.push(objTemp1);
                                    }
                                    this.$set(this.form.areaDefineScore, obj.id+'define'+i,arrData);
                                    this.$set(this.form.areaDefineScore, obj.id+'defineLabel'+i,areaDefineScoreLabel);
                                }else{
                                    // 选择值为空不存在，使用默认的
                                    let objTemp3={};objTemp3.id=[];objTemp3.item="";objTemp3.indexStudent=[];
                                    let data3=[];data3.push(objTemp3);
                                    this.$set(this.form.areaDefineScore, obj.id+'define'+i,data3);
                                }
                                
                           }else if(obj.indexType == 'self'){ // 个人

                                // 自评得分
                                if(obj.selfDefineScore!=undefined){
                                    let selfDefineScore=JSON.parse(obj.selfDefineScore).value;
                                    let selfDefineScoreLabel=JSON.parse(obj.selfDefineScore).label;
                                    let arrData=[];
                                    for(let n=0;n<selfDefineScore.length;n++){
                                        let arrObj=selfDefineScore[n];
                                        let objTemp1={};
                                        objTemp1.id=arrObj.id;
                                        objTemp1.item=arrObj.item;
                                        arrData.push(objTemp1);
                                    }
                                    this.$set(this.form.selfDefineScore, obj.id+'define'+i,arrData);
                                    this.$set(this.form.selfDefineScore, obj.id+'defineLabel'+i,selfDefineScoreLabel);
                                }else{
                                    // 选择值为空不存在，使用默认的
                                    let objTemp1={};objTemp1.id=[];objTemp1.indexStudent=[];
                                    let data1=[];data1.push(objTemp1);
                                    this.$set(this.form.selfDefineScore, obj.id+'define'+i,data1);
                                }
                                
                                // 学校得分
                                if(obj.schoolDefineScore!=undefined){
                                    let schoolDefineScore=JSON.parse(obj.schoolDefineScore).value;
                                    let schoolDefineScoreLabel=JSON.parse(obj.schoolDefineScore).label;
                                    let arrData=[];
                                    for(let n=0;n<schoolDefineScore.length;n++){
                                        let arrObj=schoolDefineScore[n];
                                        let objTemp1={};
                                        objTemp1.id=arrObj.id;
                                        objTemp1.item=arrObj.item;
                                        arrData.push(objTemp1);
                                    }
                                    this.$set(this.form.schoolDefineScore, obj.id+'define'+i,arrData);
                                    this.$set(this.form.schoolDefineScore, obj.id+'defineLabel'+i,schoolDefineScoreLabel);
                                }else{
                                    // 选择值为空不存在，使用默认的
                                    let objTemp2={};objTemp2.id=[];objTemp2.indexStudent=[];
                                    let data2=[];data2.push(objTemp2);
                                    this.$set(this.form.schoolDefineScore, obj.id+'define'+i,data2);
                                }
                                
                                // 学区得分
                                if(obj.areaDefineScore!=undefined){
                                    let areaDefineScore=JSON.parse(obj.areaDefineScore).value;
                                    let areaDefineScoreLabel=JSON.parse(obj.areaDefineScore).label;
                                    let arrData=[];
                                    for(let n=0;n<areaDefineScore.length;n++){
                                        let arrObj=areaDefineScore[n];
                                        let objTemp1={};
                                        objTemp1.id=arrObj.id;
                                        objTemp1.item=arrObj.item;
                                        arrData.push(objTemp1);
                                    }
                                    this.$set(this.form.areaDefineScore, obj.id+'define'+i,arrData);
                                    this.$set(this.form.areaDefineScore, obj.id+'defineLabel'+i,areaDefineScoreLabel);
                                }else{
                                    // 选择值为空不存在，使用默认的
                                    let objTemp3={};objTemp3.id=[];objTemp3.indexStudent=[];
                                    let data3=[];data3.push(objTemp3);
                                    this.$set(this.form.areaDefineScore, obj.id+'define'+i,data3);
                                }
                           }

                           // 自我评述
                           this.$set(this.form.selfComment, 'selfComment'+i,obj.selfComment);
                           // 自我评述附件
                           let fileArr=[];
                           for(let j=0;j<obj.selfCommentFile.length;j++){
                                let selfCommentFile=obj.selfCommentFile[j];
                                let fileObj={};
                                fileObj.fileName=selfCommentFile.fileName;
                                fileObj.filePath=selfCommentFile.filePath;
                                fileObj.fileUrl=selfCommentFile.url;
                                fileObj.fileType=selfCommentFile.fileType;
                                fileArr.push(fileObj);
                           }
                           this.form.selfCommentFile['selfCommentFile'+i]=fileArr;
                           // 学校评述
                           this.$set(this.form.schoolComments, 'schoolComments'+i,obj.schoolComments);
                           // 学区评述
                           this.$set(this.form.areaComments, 'areaComments'+i,obj.areaComments);


                           // 自我得分，学校得分，学区得分
                           if(obj.indexScore > 0){
                              // 自我得分
                              if(obj.selfScore!=undefined && obj.selfScore != 0.00){
                                this.$set(this.form.selfScore, 'selfScore'+i,obj.selfScore.toFixed(2));
                              }
                              // 学校得分 
                              if(obj.schoolScore!=undefined && obj.schoolScore != 0.00){
                                this.$set(this.form.schoolScore, 'schoolScore'+i,obj.schoolScore.toFixed(2));
                              }
                              // 学区得分 
                              if(obj.areaScore!=undefined && obj.areaScore != 0.00){
                                this.$set(this.form.areaScore, 'areaScore'+i,obj.areaScore.toFixed(2));
                              }
                           }
                           // 自我得分Label
                           if(obj.selfScoreLabel!=undefined && obj.selfScoreLabel!=""){
                                this.$set(this.form.selfScoreLabel, 'selfScoreLabel'+i,obj.selfScoreLabel);
                           }
                           // 学校得分Label
                           if(obj.schoolScoreLabel!=undefined && obj.schoolScoreLabel!=""){
                                this.$set(this.form.schoolScoreLabel, 'schoolScoreLabel'+i,obj.schoolScoreLabel);
                           }
                           // 学区得分Label
                           if(obj.areaScoreLabel!=undefined && obj.areaScoreLabel!=""){
                                this.$set(this.form.areaScoreLabel, 'areaScoreLabel'+i,obj.areaScoreLabel);
                           }

                           tempData.push(obj);
                        }
                        this.indexData=tempData;
                        // 初始ID存储
                        this.form.indexId=[];
                        for(let i=0;i<this.indexData.length;i++){
                            this.form.indexId.push(this.indexData[i].id);
                        }

                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    // this.$forceUpdate(); //强制更新
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取得分类型
            getScoreTypes(){
                let url  = this.teacherAssessBaseTypeListUrl;
                let data = {
                    deptId:this.deptId,
                    type:1 // 类型（1-得分类型，2-项目，3-级别）
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.scoreTypes = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取学生
            getStudents(){
                let url  = this.listCascaderUser;
                let data = {
                    deptId:this.deptId,
                    personType: 1//人员类型（1-学生，2-教职）
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.students = res.data;
                    //   console.log("学生数据:"+JSON.stringify(this.students))
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取级别/表彰
            getBaseTypeCascader(type){
                let url  = this.teacherAssessBaseTypeCascaderListUrl;
                let data = {
                    deptId:this.deptId,
                    type: type // 类型（1-得分类别，2-级别，3-表彰）
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.selects));
                    if(res.status == 200){
                        // 类型（1-得分类别，2-级别，3-表彰） 
                        if(type == 2){
                            this.levelData = res.data.selects;
                        }else if(type == 3){
                            this.citeData = res.data.selects;
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getFile(event,index){
                // console.log('上传文件下标：'+index);
                let file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    // 上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        
                        this.loading=true;
                        this.loadingText="上传中...";
                        this.uploadForm=new FormData(); 
                        // 上传文件
                        this.uploadForm.append('file', file[i]);
                        this.$axios.post(this.uploadUrl, this.uploadForm).then((res) => {
                            if(res.data.status == 200){
                                let f=res.data.data;
                                let selfCommentFile=this.form.selfCommentFile['selfCommentFile'+index];
                                if(selfCommentFile == undefined || selfCommentFile == null){
                                    this.form.selfCommentFile['selfCommentFile'+index]=[];
                                }
                                this.form.selfCommentFile['selfCommentFile'+index].push(f);
                                this.$forceUpdate(); //强制更新
                                this.loading=false;
                            }else{
                                this.$commonFn.showTip(res.data.message, 3);
                                this.loading=false;
                            }
                        }, (err) => {
                            this.loading=false;
                            console.log(err)
                            this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                        });
                    }else{
                        this.$commonFn.showTip('无法识别到该文件类型，请添加上扩展名',3);
                    }
                }
            },
            // 删除文件
            deleteFile(filePath){
                // 删除文件，根据文件路径删除
                for(let i=0;i<this.indexData.length;i++){
                    let selfCommentFile=this.form.selfCommentFile['selfCommentFile'+i];
                    if(selfCommentFile == undefined || selfCommentFile == null){
                        this.form.selfCommentFile['selfCommentFile'+i]=[];
                    }
                    
                    // 找出删除的文件，将文件删除，然后退出
                    let isPass=false;
                    for(let j=0;j<this.form.selfCommentFile['selfCommentFile'+i].length;j++){
                        let f=this.form.selfCommentFile['selfCommentFile'+i][j];
                        if(filePath == f.filePath){
                            this.form.selfCommentFile['selfCommentFile'+i].splice(j,1);
                            this.$forceUpdate(); //强制更新
                            isPass=true;
                            break;
                        }
                    }
                    
                    if(isPass){
                        break;
                    }
                }
            },
            lookFile(url){
                window.open(url);
            },
            keyupEvent(e,index,indexScore,type){ // 自我得分自动切换分数
                // 获取选中分数
                let v="";
                if(type == 1){
                    v=this.form.selfScore['selfScore'+index];
                }else if(type == 2){
                    v=this.form.schoolScore['schoolScore'+index];
                }else if(type == 3){
                    v=this.form.areaScore['areaScore'+index];
                }
                if(v == undefined){
                    return;
                }
                // 验证分数是否合法
                let r = /^([1-9]\d*|0)(\.\d{1,2})?$/;
                let b = r.test(v);
                if(!b){
                    let count=v.split(".").length;
                    let lastVal=v.charAt(v.length-1);
                    // 输入多余的点,去除
                    if(count>2){
                        v = v.substr(0, v.length - 1);
                    }else if(lastVal !='.'){
                        v = v.substr(0, v.length - 1);
                    }
                }
                console.log(v);
                if(type == 1){ // 自评
                    if(parseInt(v)>indexScore){
                        this.form.selfScore['selfScore'+index]=indexScore;
                    }else{
                        this.form.selfScore['selfScore'+index]=v;
                    }
                }else if(type == 2){ // 学校
                    if(parseInt(v)>indexScore){
                        this.form.schoolScore['schoolScore'+index]=indexScore;
                    }else{
                        this.form.schoolScore['schoolScore'+index]=v;
                    }
                }else if(type == 3){ // 学区
                    if(parseInt(v)>indexScore){
                        this.form.areaScore['areaScore'+index]=indexScore;
                    }else{
                        this.form.areaScore['areaScore'+index]=v;
                    }
                }
            },
            addScore(data,index,type){ //自动得分新增
                if(data.indexType == 'student'){ // 学生
                    let obj={};obj.id=[];obj.item="";obj.indexStudent=[];
                    if(type == 1){ // 自评得分
                        let v=this.form.selfDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 2){ // 学校得分
                        let v=this.form.schoolDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 3){ // 学区得分
                        let v=this.form.areaDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }
                }else if(data.indexType == 'self'){ // 老师
                    let obj={};obj.id=[];;
                    if(type == 1){ // 自评得分
                        let v=this.form.selfDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 2){ // 学校得分
                        let v=this.form.schoolDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 3){ // 学区得分
                        let v=this.form.areaDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }
                }
                this.$forceUpdate(); //强制更新
            },
            delScore(data,index,n,type){ //自动得分删除
                // console.log('自评得分：'+JSON.stringify(this.form.selfDefineScore[data.id+'students'+index]));
                if(data.indexType == 'student'){ // 学生
                    if(type == 1){ // 自评得分
                        this.form.selfDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 2){ // 学校得分
                        this.form.schoolDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 3){ // 学区得分
                        this.form.areaDefineScore[data.id+'define'+index].splice(n,1);
                    }
                    this.selecAutoScore(data,index,type);
                }else if(data.indexType == 'self'){ // 老师
                    if(type == 1){ // 自评得分
                        this.form.selfDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 2){ // 学校得分
                        this.form.schoolDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 3){ // 学区得分
                        this.form.areaDefineScore[data.id+'define'+index].splice(n,1);
                    }
                    this.selecAutoScore(data,index,type);
                }
                this.$forceUpdate(); //强制更新
            },
            selecAutoScore(indexData,index,type){ // 算自动选中的分数
                let url  = this.teacherAssessBaseTypeGetAutoScoreUrl;
                let selects="";
                if(type == 1){ // 自评得分
                   selects=JSON.stringify(this.form.selfDefineScore[indexData.id+'define'+index]);
                }else if(type == 2){ // 学校得分
                    selects=JSON.stringify(this.form.schoolDefineScore[indexData.id+'define'+index]);
                }else if(type == 3){ // 学区得分
                    selects=JSON.stringify(this.form.areaDefineScore[indexData.id+'define'+index]);
                }
                let data = {
                    selectScore:selects
                };
                // console.log(JSON.stringify(data));
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        let total=res.data;
                        // console.log('后台获取分数：'+total);
                        if(total>indexData.indexScore){
                            total=indexData.indexScore;
                        }
                        // console.log('赋值的分数：'+total);
                        if(indexData.indexType == 'student'){ // 学生
                            if(type == 1){ // 自评得分
                                this.form.selfScore['selfScore'+index]=total;
                            }else if(type == 2){ // 学校得分
                                this.form.schoolScore['schoolScore'+index]=total;
                            }else if(type == 3){ // 学区得分
                                this.form.areaScore['areaScore'+index]=total;
                            }
                        }else if(indexData.indexType == 'self'){ // 老师
                            if(type == 1){ // 自评得分
                                this.form.selfScore['selfScore'+index]=total;
                            }else if(type == 2){ // 学校得分
                                this.form.schoolScore['schoolScore'+index]=total;
                            }else if(type == 3){ // 学区得分
                                this.form.areaScore['areaScore'+index]=total;
                            }
                        }
                        this.$forceUpdate(); //强制更新
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                }); 
            },
            // 保存方法
            save(){
                
                let isPass=true;
                // 验证学校审批，学区审批
                // selectSign:1-填写，2-学校审批，3-学区审批，4-查看
                if(this.selectSign == 2){
                    let url  = this.teacherAssessSingleUrl;
                    let data = {
                        processStatus:this.selectSign,
                        id:this.teacherTemplateManageId
                    };
                    this.apiPost(url,data).then((res) => {
                        if(res.status == 200){
                            
                            // console.log(JSON.stringify(this.indexData));
                            for(let i=0;i<this.indexData.length;i++){
                                if(this.form.schoolComments['schoolComments'+i] == undefined){
                                    isPass=false;
                                    break;
                                }
                            }
                            if(!isPass){
                                this.$commonFn.showTip('【'+this.tabTitle+'】页面还有考核项需填写批注，请全部完成后再提交',3);
                                return;
                            }
                            // 算出自评+学校评分分数值
                            let selfScore=0;let schoolScore=0;
                            for(let i=0;i<this.indexData.length;i++){
                                // 自评得分
                                if(this.form.selfScore['selfScore'+i] != undefined){
                                selfScore+=Number(this.form.selfScore['selfScore'+i]);
                                }
                                // 学校评分
                                if(this.form.schoolScore['schoolScore'+i] != undefined){
                                    schoolScore+=Number(this.form.schoolScore['schoolScore'+i]);
                                }
                            }
                            let msg=this.selectName+"【"+this.tabTitle+"】自评分数是"+selfScore+"；学校审核后的分数是"+schoolScore+"，请确认是否正确并提交？";
                            this.$commonFn.showConfirm2(msg,this.saveSuccess);
 
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                    });

                }else if(this.selectSign == 3){
                    let url  = this.teacherAssessSingleUrl;
                    let data = {
                        processStatus:this.selectSign,
                        id:this.teacherTemplateManageId
                    };
                    this.apiPost(url,data).then((res) => {
                        if(res.status == 200){

                            for(let i=0;i<this.indexData.length;i++){
                                if(this.form.areaComments['areaComments'+i] == undefined){
                                    isPass=false;
                                    break;
                                }
                            }
                            if(!isPass){
                                this.$commonFn.showTip('【'+this.tabTitle+'】页面还有考核项需填写批注，请全部完成后再提交',3);
                                return;
                            }
                            // 算出自评+学校评分+学区评分分数值
                            let selfScore=0;let schoolScore=0;let areaScore=0;
                            for(let i=0;i<this.indexData.length;i++){
                                // 自评得分
                                if(this.form.selfScore['selfScore'+i] != undefined){
                                selfScore+=Number(this.form.selfScore['selfScore'+i]);
                                }
                                // 学校评分
                                if(this.form.schoolScore['schoolScore'+i] != undefined){
                                    schoolScore+=Number(this.form.schoolScore['schoolScore'+i]);
                                }
                                // 学区评分
                                if(this.form.areaScore['areaScore'+i] != undefined){
                                    areaScore+=Number(this.form.areaScore['areaScore'+i]);
                                }
                            }
                            let msg=this.selectName+"【"+this.tabTitle+"】自评分数是"+selfScore
                                +"；学校审核后的分数是"+schoolScore+"；学区审核后的分数是"+areaScore+"，请确认是否正确并提交？";
                            this.$commonFn.showConfirm2(msg,this.saveSuccess);
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                    });

                }else{
                    this.saveSuccess();
                }
            },
            saveSuccess(){
                let url  = this.teacherAssessIndexUpdateUrl;
                let data = {
                    selectSign:this.selectSign,
                    indexId:JSON.stringify(this.form.indexId),
                    indexName:JSON.stringify(this.form.indexName),
                    selfCommentFile:JSON.stringify(this.form.selfCommentFile),
                    selfComment:JSON.stringify(this.form.selfComment),
                    selfScore:JSON.stringify(this.form.selfScore),
                    selfDefineScore:JSON.stringify(this.form.selfDefineScore),
                    selfScoreLabel:JSON.stringify(this.form.selfScoreLabel),
                    schoolComments:JSON.stringify(this.form.schoolComments),
                    schoolScore:JSON.stringify(this.form.schoolScore),
                    schoolScoreLabel:JSON.stringify(this.form.schoolScoreLabel),
                    schoolDefineScore:JSON.stringify(this.form.schoolDefineScore),
                    areaComments:JSON.stringify(this.form.areaComments),
                    areaScore:JSON.stringify(this.form.areaScore),
                    areaScoreLabel:JSON.stringify(this.form.areaScoreLabel),
                    areaDefineScore:JSON.stringify(this.form.areaDefineScore),
                };
                // console.log(JSON.stringify(data));
                // return;
                this.loading=true;
                this.loadingText="保存中...";
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .el-tabs__content {
        height: 500px;
        overflow: scroll;
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/teacherAssess/gkxq/Occupation.vue